module.exports = __webpack_public_path__ + "img/logo_7.ecccd45e.png";